import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import { get } from 'lodash';
import moment from 'moment';

export function getRecommendation(params) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.RECOMMENDATION,
        params: params,
        parser: data => recommendationDataParser(data),
    }).get();
}

const recommendationDataParser = (data = {}) => {
    return {
        ...data.data
    }
};